import { render, staticRenderFns } from "./RouteName.vue?vue&type=template&id=f5075f7c&scoped=true&"
import script from "./RouteName.vue?vue&type=script&lang=js&"
export * from "./RouteName.vue?vue&type=script&lang=js&"
import style0 from "./RouteName.vue?vue&type=style&index=0&id=f5075f7c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5075f7c",
  null
  
)

export default component.exports